import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconFolderLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.333 3.99935H7.99967L6.66634 2.66602H2.66634C1.93301 2.66602 1.33967 3.26602 1.33967 3.99935L1.33301 11.9993C1.33301 12.7327 1.93301 13.3327 2.66634 13.3327H13.333C14.0663 13.3327 14.6663 12.7327 14.6663 11.9993V5.33268C14.6663 4.59935 14.0663 3.99935 13.333 3.99935ZM13.333 11.9993H2.66634V5.33268H13.333V11.9993Z",
		fill: "#333333"
	})
});
export default SvgIconFolderLine;
